// extracted by css-extract-rspack-plugin
export default {"trigger":"Y2461gQWOMkkny1F","popover":"U93ZLzXMS_EMujQn"};